import StatusDropDown from './StatusDropDown';
type mapperType = {
    [key: string]: any;
};
const mapper: mapperType = {
    STATUS: StatusDropDown
};
export default mapper;
